import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@/components/ui/skeleton';
const ProfileContentSkeleton = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className="h-16 w-16 rounded-full" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center gap-4">{t0}<div className="flex flex-col gap-2"><Skeleton className="h-4 w-40" /><Skeleton className="h-3 w-56" /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="grid grid-cols-1 items-center justify-between gap-4 rounded-lg border border-gray-100 p-4 md:grid-cols-2">{t1}<div className="flex justify-end"><Skeleton className="h-9 w-40 rounded-md" /></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="grid grid-cols-1 gap-4 md:grid-cols-3">{Array.from({
        length: 7
      }).map(_temp)}</div>;
    t4 = <Skeleton className="h-px w-full" />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex w-full flex-col gap-6 rounded-lg bg-white p-6 shadow-sm">{t2}{t3}{t4}<div className="grid grid-cols-1 gap-4 md:grid-cols-3">{Array.from({
          length: 3
        }).map(_temp2)}</div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
export default ProfileContentSkeleton;
function _temp(_, i) {
  return <div key={i} className="flex flex-col gap-2 rounded-md border bg-gray-50 p-4"><Skeleton className="h-3 w-24" /><Skeleton className="h-4 w-full max-w-35" /></div>;
}
function _temp2(__0, i_0) {
  return <div key={i_0} className="flex flex-col gap-2 rounded-md border bg-gray-50 p-4"><Skeleton className="h-3 w-36" /><Skeleton className="h-4 w-40" /></div>;
}